const useNextTick = () => {
    return {
        nextTick: (callback) => {
            setTimeout(callback, 0);
        }
    }    
}

export default useNextTick;